import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getCloudId } from '../constants';
import { getConfluencePageAri } from './ari';

// Uncomment for proxy in Atlaskit, which will route to hello.atlassian.net
// const BASE_URL = 'https://localhost:9876';
var BASE_URL = "/gateway/api/ex/confluence/".concat(getCloudId());
var API_BASE_URL = "".concat(BASE_URL, "/wiki/api/v2");
var COMMON_HEADERS = {
  'Content-Type': 'application/json',
  Accept: 'application/json'
};
var getContentPropertiesUrl = function getContentPropertiesUrl(_ref) {
  var pageId = _ref.pageId,
    contentPropertyId = _ref.contentPropertyId;
  var url = "".concat(API_BASE_URL, "/pages/").concat(pageId, "/properties");
  if (contentPropertyId) {
    return "".concat(url, "/").concat(contentPropertyId);
  }
  return url;
};
var getGraphQLPropertiesUrl = function getGraphQLPropertiesUrl() {
  return "/cgraphql/api/graphql";
};
export var createContentProperty = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var pageId, key, value, url, body, response, contentProperty;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          pageId = _ref2.pageId, key = _ref2.key, value = _ref2.value;
          url = getContentPropertiesUrl({
            pageId: pageId
          });
          body = JSON.stringify({
            key: key,
            value: value
          });
          _context.next = 5;
          return fetch(url, {
            method: 'POST',
            headers: COMMON_HEADERS,
            body: body
          });
        case 5:
          response = _context.sent;
          if (response.ok) {
            _context.next = 8;
            break;
          }
          throw new Error("Failed to create content property: ".concat(response.statusText));
        case 8:
          _context.next = 10;
          return response.json();
        case 10:
          contentProperty = _context.sent;
          return _context.abrupt("return", contentProperty);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function createContentProperty(_x) {
    return _ref3.apply(this, arguments);
  };
}();
export var getContentProperty = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4) {
    var pageId, contentPropertyId, signal, url, response, contentProperty;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          pageId = _ref4.pageId, contentPropertyId = _ref4.contentPropertyId, signal = _ref4.signal;
          url = getContentPropertiesUrl({
            pageId: pageId,
            contentPropertyId: contentPropertyId
          });
          _context2.next = 4;
          return fetch(url, {
            method: 'GET',
            headers: COMMON_HEADERS,
            signal: signal
          });
        case 4:
          response = _context2.sent;
          if (response.ok) {
            _context2.next = 7;
            break;
          }
          throw new Error("Failed to get content property: ".concat(response.statusText));
        case 7:
          _context2.next = 9;
          return response.json();
        case 9:
          contentProperty = _context2.sent;
          return _context2.abrupt("return", contentProperty);
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getContentProperty(_x2) {
    return _ref5.apply(this, arguments);
  };
}();
var getQuery = function getQuery(documentARI, key, value) {
  return "mutation {\n\t  confluence {\n\t    updateValuePageProperty(input: {\n\t      pageId: \"".concat(documentARI, "\",\n\t      key: \"").concat(key, "\",\n\t      value: \"").concat(value, "\",\n\t      useSameVersion: true\n\t    }) {\n\t      pageProperty {\n\t        key,\n\t        value\n\t      }\n\t    }\n\t  }\n\t}");
};
export var updateContentProperty = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref6) {
    var pageId, key, value, url, documentARI, query, bodyData, response, contentProperty;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          pageId = _ref6.pageId, key = _ref6.key, value = _ref6.value;
          url = getGraphQLPropertiesUrl();
          documentARI = getConfluencePageAri(pageId); // eslint-disable-next-line require-unicode-regexp
          query = getQuery(documentARI, key, value.replace(/"/g, '\\"'));
          bodyData = {
            query: query
          };
          _context3.next = 7;
          return fetch(url, {
            method: 'POST',
            headers: COMMON_HEADERS,
            body: JSON.stringify(bodyData)
          });
        case 7:
          response = _context3.sent;
          if (response.ok) {
            _context3.next = 10;
            break;
          }
          throw new Error("Failed to update content property: ".concat(response.statusText));
        case 10:
          _context3.next = 12;
          return response.json();
        case 12:
          contentProperty = _context3.sent;
          return _context3.abrupt("return", contentProperty);
        case 14:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function updateContentProperty(_x3) {
    return _ref7.apply(this, arguments);
  };
}();